import styled from 'styled-components';

const SectionLineTitle = styled.h3`
  &::before{
    content: "";
    width: 51px;
    height: 1px;
    position: absolute;
    left: 4px;
    top: ${props => props.size === 'small' ? '9' : '13'}px;
    background-color: #b08f6e;
  }

  height: 20px;
  font-family: MinionPro;
  font-size: ${props => props.size === 'small' ? '15' : '20'}px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.45;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  text-align: left;
  color: #b08f6e;
  padding-left: 63px;
  text-transform: uppercase;
  margin-top: -12px;
  margin-bottom: 50px;
  position: relative;
  display: inline-block;

  h3{
    margin: 0;
  }
`;

export default SectionLineTitle;